// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Plus = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M44 44V12.5a4 4 0 1 1 8 0V44h31.5a4 4 0 1 1 0 8H52v31.5a4 4 0 1 1-8 0V52H12.5a4 4 0 1 1 0-8H44Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default Plus;
